import { MutationTree } from 'vuex'
import { Consultation, TodayState } from './types'

export enum TodayMutations {
  SET_LOADING = 'SET_LOADING',
  SET_LIST = 'SET_LIST'
}

export const mutations: MutationTree<TodayState> = {
  [TodayMutations.SET_LOADING](state: TodayState, payload: boolean) {
    state.loadingList = payload
  },

  [TodayMutations.SET_LIST](state: TodayState, payload: Array<Consultation>) {
    state.consultationsList = payload
  }
}
